import React, { MutableRefObject, PropsWithChildren, useMemo } from 'react'

import NextImage from 'next/image'
import { CSSProperties } from 'styled-components'

import { useScreen } from '@/store/screen'

export type ImageProps = PropsWithChildren<{
  src: string
  alt: string
  fill?: boolean
  priority?: boolean
  responsiveSizes?: {
    [key: `${number}`]: {
      height: number
      width: number
    }
  }
  defaultSize?: {
    height: number
    width: number
  }
  className?: string
  style?: CSSProperties
  ref?: MutableRefObject<HTMLImageElement | null>
  fileName?: string
}>

export const Image: React.FC<ImageProps> = ({
  src,
  alt,
  fill,
  priority = false,
  responsiveSizes,
  defaultSize = {
    width: 100,
    height: 100,
  },
  className,
  style,
  ref,
  fileName,
}) => {
  const {
    windowSize: { width: screenWidth },
  } = useScreen()

  const { width, height } = useMemo(() => {
    if (responsiveSizes && screenWidth) {
      const keys = Object.keys(responsiveSizes).map(Number)

      const key = keys.find((i) => i >= screenWidth)

      if (key) {
        return responsiveSizes[`${key}`]
      }

      return defaultSize
    }

    return defaultSize
  }, [screenWidth, defaultSize, responsiveSizes])

  return (
    <NextImage
      src={src}
      alt={alt || String(fileName)}
      {...(fill ? { fill } : { width, height })}
      className={className}
      style={style}
      unoptimized={process.env.VERCEL_ENV !== 'production'}
      ref={ref}
      priority={priority}
    />
  )
}
